const careerRecommendations = {
    Technology: {
        careers: ['Software Developer', 'AI - Prompt Engineer', 'Data Scientist', 'Blockchain Developer'],
        description: 'Your technical aptitude and curiosity make technology an ideal field for you.',
        articles: ['Tech Careers for the Future', 'AI Revolution', 'Learning Cloud Technologies']
    },
    Finance: {
        careers: ['Investment Analyst', 'Trader', 'Banker', 'Auditor'],
        description: 'Your analytical mind and attention to detail are perfect for the financial sector.',
        articles: ['Careers in Finance', 'Understanding Investment Banking', 'Future of Financial Markets']
    },
    Media: {
        careers: ['Director', 'Video Editor', 'Screenplay Writer', 'Cinematographer', 'Journalism'],
        description: 'Your creativity and storytelling ability shine in media-related roles.',
        articles: ['Future of Digital Media', 'How to Build a Media Career', 'Exploring Creative Content']
    },
    Cinema: {
        careers: ['Director', 'Video Editor', 'Screenplay Writer', 'Cinematographer'],
        description: 'Your creativity and storytelling ability shine in media-related roles.',
        articles: ['Future of Digital Media', 'How to Build a Media Career', 'Exploring Creative Content']
    },
    Entertainment: {
        careers: ['Director', 'Screenwriter', 'Choreographer', 'Animator'],
        description: 'Your passion for performing and creating makes entertainment an exciting field.',
        articles: ['Careers in Film Making', 'The Art of Storytelling', 'Breaking into Entertainment']
    },
    Psychology: {
        careers: ['Clinical Psychologist', 'Industrial-Organizational Psychologist', 'Counselor'],
        description: 'Your empathy and understanding of human behavior make you suitable for psychology.',
        articles: ['Careers in Psychology', 'Future of Counseling', 'Human Behavior Analysis']
    },
    Education: {
        careers: ['Teacher', 'Instructional Designer', 'Educational Consultant'],
        description: 'Your passion for teaching and knowledge-sharing points to a rewarding education career.',
        articles: ['Future of Education', 'EdTech Careers', 'Modern Teaching Strategies']
    },
    Environment: {
        careers: ['Climate Scientist', 'Sustainability Expert', 'Conservationist'],
        description: 'Your dedication to preserving the environment aligns with careers in environmental science.',
        articles: ['Careers in Climate Change', 'Sustainability Careers', 'Future of Renewable Energy']
    },
    Biology: {
        careers: ['Biomedical Scientist', 'Geneticist', 'Ecologist'],
        description: 'Your interest in life sciences makes biology an ideal career path.',
        articles: ['Careers in Biology', 'Advancements in Biomedical Research', 'Ecology and Conservation']
    },
    Agriculture: {
        careers: ['Agronomist', 'Food Scientist', 'Agricultural Engineer'],
        description: 'Your connection to nature and cultivation makes agriculture a perfect fit.',
        articles: ['Careers in Modern Farming', 'Sustainable Agriculture Practices', 'Food Science Careers']
    },
    Arts: {
        careers: ['Painter', 'Graphic Designer', 'Sculptor', 'Art Therapist'],
        description: 'Your creativity and artistic talents make the arts a fulfilling career choice.',
        articles: ['Careers in Visual Arts', 'Creative Industry Trends', 'Exploring Art Therapy']
    },
    "Computer Science": {
        careers: ['Software Engineer', 'Machine Learning Engineer', 'Game Developer'],
        description: 'Your technical expertise suits you for roles in computer science.',
        articles: ['Building a Career in Computer Science', 'AI and Machine Learning Trends']
    },
    Robotics: {
        careers: ['Robotics Engineer', 'Automation Specialist', 'Embedded Systems Developer'],
        description: 'Your interest in building intelligent systems aligns with a career in robotics.',
        articles: ['Future of Robotics', 'Careers in Automation', 'Building Intelligent Machines']
    },
    Engineering: {
        careers: ['Civil Engineer', 'Mechanical Engineer', 'Electrical Engineer'],
        description: 'Your problem-solving and technical skills suit engineering professions.',
        articles: ['Engineering Careers', 'Innovations in Civil Engineering', 'Future of Technology']
    },
    Astronomy: {
        careers: ['Astronomer', 'Astrophysicist', 'Planetary Scientist'],
        description: 'Your fascination with the cosmos makes astronomy an exciting field.',
        articles: ['Careers in Astronomy', 'Exploring Space Science', 'The Future of Space Exploration']
    },
    Research: {
        careers: ['Research Scientist', 'Academic Researcher', 'Lab Technician'],
        description: 'Your curiosity and analytical mindset align with research careers.',
        articles: ['Careers in Research', 'How to Excel in Academia', 'Scientific Breakthroughs']
    },
    "Adventure & Tourism": {
        careers: ['Adventure Guide', 'Expedition Planner', 'Travel Blogger'],
        description: 'Your love for adventure and exploration makes this an exciting field.',
        articles: ['Careers in Adventure Tourism', 'Exploring the Outdoors', 'Sustainable Tourism']
    },
    "Marine Biology": {
        careers: ['Marine Biologist', 'Aquatic Ecologist', 'Oceanographer'],
        description: 'Your interest in aquatic life and ecosystems aligns with marine biology.',
        articles: ['Careers in Marine Biology', 'Conservation of Marine Ecosystems', 'Exploring Ocean Science']
    },
    "Environmental Science": {
        careers: ['Environmental Consultant', 'Sustainability Specialist', 'Climate Policy Analyst'],
        description: 'Your dedication to the planet aligns with careers in environmental science.',
        articles: ['Careers in Environmental Science', 'Sustainable Development Careers']
    },
    Politics: {
        careers: ['Political Analyst', 'Legislative Assistant', 'Policy Advisor'],
        description: 'Your interest in governance and public affairs makes politics a suitable field.',
        articles: ['Careers in Politics', 'The Role of Policy Advisors', 'Understanding Political Systems']
    },
    Social_work: {
        careers: ['Social Worker', 'Community Organizer', 'Case Manager'],
        description: 'Your compassion and desire to help others make social work fulfilling for you.',
        articles: ['Careers in Social Work', 'Building Communities', 'Future of Non-Profit Work']
    },
    Academia: {
        careers: ['University Professor', 'Academic Researcher', 'Dean'],
        description: 'Your passion for knowledge and mentorship makes academia a great fit.',
        articles: ['Careers in Academia', 'Academic Leadership', 'Research in Higher Education']
    },
    Design: {
        careers: ['Interior Designer', 'Product Designer', 'UX Researcher'],
        description: 'Your creativity and problem-solving skills make you ideal for design roles.',
        articles: ['Careers in Design', 'Exploring UX Design', 'Future of Product Design']
    },
    Business: {
        careers: ['Entrepreneur', 'Business Analyst', 'Strategy Consultant'],
        description: 'Your leadership and strategic thinking align with careers in business.',
        articles: ['Careers in Business Strategy', 'The World of Consulting', 'Building Startups']
    },
    Innovation: {
        careers: ['Product Innovator', 'Tech Entrepreneur', 'Innovation Consultant'],
        description: 'Your creative problem-solving skills align with careers focused on innovation.',
        articles: ['Careers in Innovation', 'Future of Technology', 'Building New Solutions']
    },
    "Dairy & Animals": {
        careers: ['Veterinarian', 'Animal Nutritionist', 'Dairy Farm Manager', 'Animal Geneticist', 'Livestock Specialist'],
        description: 'Your passion for animals and agricultural sciences makes this field exciting and meaningful.',
        articles: ['Modern Dairy Farming Techniques', 'Career Paths in Animal Science', 'Veterinary Medicine Innovations']
    },
    "History & Language": {
        careers: ['Historian', 'Linguist', 'Translator', 'Archaeologist', 'Cultural Anthropologist'],
        description: 'Your love for understanding human cultures and communication makes this field fascinating.',
        articles: ['Careers in Linguistic Research', 'Exploring Global History', 'Translation in the Digital Age']
    },
    Advertisement: {
        careers: ['Marketing Strategist', 'Creative Director', 'Brand Manager', 'Digital Marketing Specialist', 'Content Strategist'],
        description: 'Your creativity and communication skills are perfect for the dynamic world of advertising.',
        articles: ['Future of Digital Marketing', 'Building Compelling Brand Narratives', 'Advertising in the Social Media Era']
    },
    Beautician: {
        careers: ['Cosmetologist', 'Makeup Artist', 'Esthetician', 'Hair Stylist', 'Beauty Salon Manager'],
        description: 'Your artistic skills and passion for personal care make the beauty industry an ideal field.',
        articles: ['Trends in Beauty and Wellness', 'Professional Cosmetology Careers', 'Beauty Industry Innovations']
    },
    Food: {
        careers: ['Chef', 'Food Critic', 'Nutritionist', 'Food Scientist', 'Culinary Instructor'],
        description: 'Your passion for culinary arts and nutrition opens up exciting career possibilities.',
        articles: ['Culinary Careers of the Future', 'Nutrition and Modern Cuisine', 'Innovative Food Technologies']
    },
    "Travel & Tourism": {
        careers: ['Travel Consultant', 'Tour Operator', 'Hospitality Manager', 'Tourism Marketing Specialist', 'Event Planner'],
        description: 'Your love for exploration and people makes travel and tourism an exciting career path.',
        articles: ['Future of Global Tourism', 'Sustainable Travel Trends', 'Hospitality Industry Innovations']
    },
    Aviation: {
        careers: ['Pilot', 'Air Traffic Controller', 'Aviation Engineer', 'Aerospace Technician', 'Flight Instructor'],
        description: 'Your passion for flight and technical skills make aviation a thrilling career choice.',
        articles: ['Careers in Modern Aviation', 'Future of Air Travel', 'Aerospace Technology Advances']
    },
    Photography: {
        careers: ['Photojournalist', 'Commercial Photographer', 'Wedding Photographer', 'Wildlife Photographer', 'Fashion Photographer'],
        description: 'Your eye for detail and creative vision make photography an expressive career.',
        articles: ['Digital Photography Careers', 'Visual Storytelling', 'Photography in the Digital Age']
    },
    Fashion: {
        careers: ['Fashion Designer', 'Stylist', 'Fashion Merchandiser', 'Fashion Trend Analyst', 'Textile Designer'],
        description: 'Your creativity and sense of style are perfect for the dynamic world of fashion.',
        articles: ['Future of Fashion Design', 'Sustainable Fashion Careers', 'Global Fashion Trends']
    },
    "Merchant Navy": {
        careers: ['Marine Officer', 'Navigation Officer', 'Ship Engineer', 'Maritime Logistics Specialist', 'Port Manager'],
        description: 'Your love for the sea and adventure makes the Merchant Navy an exciting career path.',
        articles: ['Careers in Maritime Industry', 'Global Shipping Trends', 'Life at Sea']
    },
    "Building and Construction": {
        careers: ['Architect', 'Construction Manager', 'Urban Planner', 'Structural Engineer', 'Building Inspector'],
        description: 'Your technical skills and vision for creating spaces make construction an ideal field.',
        articles: ['Future of Construction Technology', 'Sustainable Building Practices', 'Urban Development Careers']
    },
    "Energy & Electricity": {
        careers: ['Electrical Engineer', 'Renewable Energy Specialist', 'Power Systems Analyst', 'Energy Consultant', 'Grid Management Expert'],
        description: 'Your interest in technological solutions for energy makes this field crucial and exciting.',
        articles: ['Renewable Energy Careers', 'Future of Power Systems', 'Sustainable Energy Technologies']
    },
    "Mechanical & Industrial": {
        careers: ['Industrial Engineer', 'Manufacturing Specialist', 'Product Design Engineer', 'Quality Control Manager', 'Process Improvement Analyst'],
        description: 'Your problem-solving skills and technical aptitude are perfect for mechanical and industrial roles.',
        articles: ['Innovations in Manufacturing', 'Industry 4.0 Careers', 'Future of Industrial Engineering']
    },
    Music: {
        careers: ['Musician', 'Music Producer', 'Sound Engineer', 'Music Therapist', 'Composer'],
        description: 'Your passion for music and creativity make this a fulfilling career path.',
        articles: ['Digital Music Production', 'Music Industry Trends', 'Careers in Sound Design']
    },
    Jewelry: {
        careers: ['Jewelry Designer', 'Gemologist', 'Jewelry Appraiser', 'Goldsmith', 'Jewelry Manufacturer'],
        description: 'Your artistic skills and attention to detail make jewelry design an exciting career.',
        articles: ['Future of Jewelry Design', 'Gemstone Industry Careers', 'Artisan Craftsmanship']
    },
    Fitness: {
        careers: ['Personal Trainer', 'Fitness Coach', 'Sports Nutritionist', 'Physiotherapist', 'Wellness Consultant'],
        description: 'Your passion for health and physical wellness makes fitness a rewarding career.',
        articles: ['Fitness Industry Trends', 'Holistic Health Careers', 'Personal Training Innovations']
    },
    "Typing & Writing": {
        careers: ['Freelance Writer', 'Technical Writer', 'Content Creator', 'Transcriptionist', 'Copy Editor'],
        description: 'Your communication skills and love for language make writing a versatile career.',
        articles: ['Digital Writing Careers', 'Content Creation Trends', 'Future of Technical Writing']
    },
    "Management & Administration": {
        careers: ['Office Manager', 'Administrative Director', 'Operations Manager', 'Project Coordinator', 'Executive Assistant'],
        description: 'Your organizational skills and leadership make management roles ideal for you.',
        articles: ['Modern Office Management', 'Administrative Careers', 'Effective Workplace Leadership']
    },
    "Exotic & Unique Career": {
        careers: ['Ethical Hacker', 'Space Tourism Guide', 'Drone Operator', 'Virtual Reality Designer', 'Cryptocurrency Analyst'],
        description: 'Your curiosity and willingness to explore emerging fields make unique careers exciting.',
        articles: ['Emerging Career Trends', 'Future of Unique Professions', 'Innovative Career Paths']
    },
    Army: {
        careers: ['Military Officer', 'Defense Strategist', 'Military Intelligence', 'Military Engineer', 'Military Logistics Specialist'],
        description: 'Your discipline, leadership, and commitment to service make military careers noble and challenging.',
        articles: ['Military Career Paths', 'Defense Industry Trends', 'Leadership in Armed Forces']
    },
    "Logistics & SCM": {
        careers: ['Supply Chain Manager', 'Logistics Analyst', 'Procurement Specialist', 'Distribution Coordinator', 'Inventory Management Expert'],
        description: 'Your analytical skills and strategic thinking are perfect for logistics and supply chain roles.',
        articles: ['Future of Supply Chain', 'Logistics Industry Innovations', 'Global Trade Management']
    },
    Painting: {
        careers: ['Fine Artist', 'Illustrator', 'Art Conservator', 'Art Therapist', 'Muralist'],
        description: 'Your creativity and artistic vision make painting a fulfilling career path.',
        articles: ['Contemporary Art Careers', 'Digital Illustration Trends', 'Art as a Profession']
    },
    Investigation: {
        careers: ['Private Investigator', 'Forensic Scientist', 'Criminal Investigator', 'Legal Investigator', 'Cybersecurity Investigator'],
        description: 'Your analytical skills and curiosity make investigation careers intriguing and impactful.',
        articles: ['Modern Investigation Techniques', 'Forensic Science Careers', 'Digital Forensics']
    },
    "Statistics & Actuaries": {
        careers: ['Statistician', 'Data Analyst', 'Actuary', 'Risk Analyst', 'Research Statistician'],
        description: 'Your analytical skills and love for numbers make statistics and actuarial roles perfect.',
        articles: ['Data Science Careers', 'Future of Actuarial Profession', 'Statistical Analysis Trends']
    },
    Sports: {
        careers: ['Professional Athlete', 'Sports Coach', 'Sports Physiotherapist', 'Sports Marketing Manager', 'Sports Nutritionist'],
        description: 'Your passion for athletics and physical performance makes sports a dynamic career field.',
        articles: ['Professional Sports Careers', 'Sports Science Innovations', 'Athletic Performance Management']
    }
};

export default careerRecommendations;